// src/pages/InventoryImportModal.js
import React, { useState } from 'react';
import { Modal, Box, Typography, Button, Alert, CircularProgress, Link } from '@mui/material';
import Papa from 'papaparse';
import api from '../api/index.js'; // Importar la instancia de Axios

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 500 },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const InventoryImportModal = ({ open, onClose, storeId, onImportSuccess }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleFileChange = (e) => {
        setResult(null);
        setFile(e.target.files[0]);
    };

    const handleImport = () => {
        if (!file || !storeId) {
            setResult({ success: false, message: 'Por favor, selecciona un archivo y asegúrate de haber elegido una tienda.' });
            return;
        }
        setLoading(true);
        setResult(null);

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async (results) => {
                try {
                    const response = await api.post(`/inventory/store/${storeId}/bulk-import`, { products: results.data });
                    setResult({ success: true, data: response.data });
                    if(onImportSuccess) onImportSuccess();
                } catch (err) {
                    setResult({ success: false, message: err.response?.data?.message || 'Error en el servidor durante la importación.' });
                } finally {
                    setLoading(false);
                }
            },
            error: (error) => {
                setResult({ success: false, message: `Error al leer el archivo CSV: ${error.message}` });
                setLoading(false);
            }
        });
    };

    const templateCSV = "sku,name,purchase_price,quantity,sale_price,category_name,supplier_name,brand_name\nSKU001,Producto Ejemplo,10.50,100,19.99,Categoría 1,Proveedor A,Marca X";
    const blob = new Blob([templateCSV], { type: 'text/csv;charset=utf-8,' });
    const templateUrl = URL.createObjectURL(blob);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6">Importación Masiva de Inventario</Typography>
                <Typography variant="body2" sx={{ my: 2 }}>
                    Sube un archivo CSV con tus productos. Asegúrate de que las columnas coincidan con la plantilla. Las categorías, proveedores y marcas que no existan se crearán automáticamente.
                </Typography>
                <Link href={templateUrl} download="plantilla_inventario.csv" sx={{ mb: 2, display: 'block' }}>
                    Descargar Plantilla de Ejemplo
                </Link>
                
                <Box sx={{ my: 2 }}>
                    <Button variant="contained" component="label">
                        Seleccionar Archivo CSV
                        <input type="file" accept=".csv" hidden onChange={handleFileChange} />
                    </Button>
                    {file && <Typography sx={{ ml: 2, display: 'inline' }}>{file.name}</Typography>}
                </Box>

                <Button onClick={handleImport} disabled={!file || loading} variant="contained" color="primary">
                    {loading ? <CircularProgress size={24} /> : 'Iniciar Importación'}
                </Button>
                
                {result && (
                    <Alert severity={result.success ? 'success' : 'error'} sx={{ mt: 2 }}>
                        {result.success ? 
                            `Importación completada: ${result.data.productsCreated} creados, ${result.data.inventoryUpdated} actualizados.`
                            : result.message
                        }
                        {result.data?.errors?.length > 0 && (
                            <Box>
                                <Typography variant="body2">Errores encontrados:</Typography>
                                <ul>
                                    {result.data.errors.map((e, i) => <li key={i}>{e}</li>)}
                                </ul>
                            </Box>
                        )}
                    </Alert>
                )}
            </Box>
        </Modal>
    );
};

// --- LÍNEA DE EXPORTACIÓN CORREGIDA ---
export default InventoryImportModal;